import { getLocalizedText } from 'ppbl/utils/locale-helper'
import serverData from 'ppbl/utils/server-data'

export const generateProps = () => {
  const {
    context: { resourceBaseUrl },
  } = serverData

  const product = serverData?.startParams?.product

  const isPPBL = () => {
    if (product && (product === 'paypal' || product === 'paypal-renewal')) {
      return true
    }
    return false
  }

  const logo = {
    text: getLocalizedText('header.logoText'),
    href: getLocalizedText('header.logoHref'),
    imageUrl: isPPBL()
      ? `${resourceBaseUrl}/images/ppbl_rgb.png`
      : `${resourceBaseUrl}/images/lbaps-rgb.png`,
  }

  const headerPrimaryLink = {
    text: getLocalizedText('header.primaryText'),
    url: getLocalizedText('header.primaryLink'),
  }
  const loginInfo = {
    text: getLocalizedText('header.loginInfo'),
    button: {
      text: getLocalizedText('header.login.text'),
      url: getLocalizedText('header.login.url'),
    },
  }
  const loginButton = {
    button: [
      {
        text: getLocalizedText('header.login.text'),
        url: getLocalizedText('header.login.url'),
        target: '_self',
        type: 'Primary',
        clickEventName: 'Button_CTA',
        buttonStyle: 'ppreact',
      },
    ],
  }

  return {
    logo,
    headerPrimaryLink,
    loginInfo,
    loginButton,
    isPPBL: isPPBL(),
    product,
  }
}
